import React, { useContext, useState } from "react";
import { sum } from "lodash";
import { ProductExtraFee } from "../../../../../data/entities";
import CustomTable from "../../../../../shared/components/CustomTable";
import { StyledTableCell } from "../../../../../shared/components/CustomTable/Styled";
import { StyledNavLink } from "../../../../../shared/styled/TableStyles";
import TextBox from "../../../../../shared/components/TextBox";
import IconButton from "../../../../../shared/components/IconButton";
import DeleteIcon from "../../../../../shared/svg/DeleteIcon";
import { ContentWrapper, ProductButtonRow, ProductTableText } from "../../../../ProductOrder/single/Styled";
import { formatCurrency, formatInternationalNumber, parseInternationalToNumber } from "../../../../../utils/format";
import { TableRow } from "@mui/material";
import { AddExtraFeesModal } from "./AddProductExtraFeeModal";
import { StyledButton } from "../../../../MaterialOrder/Styled";
import { SummaryTableCell, SummaryTableRow } from "./AddProductExtraFeeModal/Styled";
import { AuthenticationContext } from "../../../../../provider/AuthenticationProvider";
import { ROLE } from "../../../../../data/enums";
import { error } from "../../../../../utils/toast";

export const ExtraFeeTableColumns = [
    { text: "Mã chi phí", icon: <></> },
    { text: "Tên chi phí", icon: <></> },
    { text: "Số lượng", icon: <></> },
    { text: "Đơn giá", icon: <></> },
    { text: "", icon: <></> },
];

interface ExtraFeeRowProps {
    item: any;
    idx: number;
    extraRowProps: any;
}

export const ExtraFeeRow = ({ item, extraRowProps }: ExtraFeeRowProps) => {
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canEdit = role === ROLE.MANAGER || role === ROLE.SALE_STAFF;

    return !item.isSummary ? (
        <TableRow>
            <StyledTableCell align="left">
                <StyledNavLink to={`/extraFees/${item.extra_fee.id}`}>
                    {item.extra_fee.id}
                </StyledNavLink>
            </StyledTableCell>
            <StyledTableCell align="left">
                {item.extra_fee.name}
            </StyledTableCell>
            <StyledTableCell align="left">
                <TextBox
                    numeric
                    text={formatInternationalNumber(item.quantity ?? "")}
                    onChangeText={(value: string) => {
                        const n = parseInternationalToNumber(value, error);
                        if (!Number.isFinite(n)) return;
                        extraRowProps.updateItemSelectedQuantity(item, n);
                    }}
                    disabled={extraRowProps.isView || !canEdit}
                />
            </StyledTableCell>
            <StyledTableCell align="left">
                {item.extra_fee.price}
            </StyledTableCell>
            <StyledTableCell align="left">
                <IconButton
                    onClick={() => extraRowProps.removeItem(item)}
                    disabled={!canEdit}
                >
                    <DeleteIcon />
                </IconButton>
            </StyledTableCell>
        </TableRow>
    ) : (
        <SummaryTableRow>
            <SummaryTableCell align="left">{item.id}</SummaryTableCell>
            <SummaryTableCell align="left">{item.name}</SummaryTableCell>
            <SummaryTableCell align="left">{item.price}</SummaryTableCell>
            <StyledTableCell align="left"></StyledTableCell>
            <StyledTableCell align="left"></StyledTableCell>
        </SummaryTableRow>
    );
};

interface extraFeeListProps {
    extraFees: ProductExtraFee[];
    mergeProduct: Function;
    isView?: boolean;
    category?: string;
}

const ProductExtraFees = ({
                              extraFees,
                              mergeProduct,
                              isView,
                              category,
                          }: extraFeeListProps) => {
    const [isextraFeeModalOpen, setIsextraFeeModalOpen] = useState(false);
    const {
        user: { role },
    } = useContext(AuthenticationContext);
    const canEdit = role === ROLE.MANAGER || role === ROLE.SALE_STAFF;

    const summaryextraFees = {
        id: `Tổng Chi phí kèm theo`,
        price: formatCurrency(
            sum(
                extraFees.map(
                    (item: ProductExtraFee) =>
                        item.extra_fee.price * item.quantity,
                ),
            ),
        ),
        isSummary: true,
    };

    const tableItems =
        extraFees.length === 0 ? [] : [...extraFees, summaryextraFees];

    const onRemoveExtraFee = (item: ProductExtraFee) => {
        const removedextraFees = extraFees.filter(
            (extraFee) => item.extra_fee.id !== extraFee.extra_fee.id,
        );
        mergeProduct({ extra_fees: removedextraFees });
    };

    const updateItemSelectedQuantity = (
        item: ProductExtraFee,
        quantity: any,
    ) => {
        const updatedExtraFees = extraFees.map((extraFee) => {
            if (item.extra_fee.id === extraFee.extra_fee.id)
                return { ...extraFee, quantity };
            return extraFee;
        });
        mergeProduct({ extra_fees: updatedExtraFees });
    };

    return (
        <>
            {isextraFeeModalOpen && canEdit && !isView && (
                <AddExtraFeesModal
                    selectedExtraFees={extraFees}
                    open={isextraFeeModalOpen}
                    handleClose={() => setIsextraFeeModalOpen(false)}
                    mergeProduct={mergeProduct}
                    category={category}
                />
            )}

            <ContentWrapper>
                <ProductTableText>Danh sách chi phí kèm theo</ProductTableText>

                <CustomTable
                    itemList={tableItems}
                    RowElement={ExtraFeeRow}
                    TableColumns={ExtraFeeTableColumns}
                    extraRowProps={{
                        removeItem: onRemoveExtraFee,
                        updateItemSelectedQuantity,
                        isView,
                    }}
                />

                {extraFees.length === 0 &&
                    "Không có chi phí kèm theo được chọn"}
                {!isView && canEdit && (
                    <ProductButtonRow>
                        <StyledButton
                            variant="contained"
                            onClick={() => setIsextraFeeModalOpen(true)}
                        >
                            Thêm chi phí kèm theo
                        </StyledButton>
                    </ProductButtonRow>
                )}
            </ContentWrapper>
        </>
    );
};

export default ProductExtraFees;
